import lozad from "lozad";
import { setBackgroundElement, buttonToTop, clickScrollToDiv, toggleItem, scrollAnimation, detectCloseElement } from "./helper";
import { header } from "./header";
import swiperInit from "./swiper";
import { product } from "./product";
$(document).ready(function () {
	setBackgroundElement();
	header.init();
	swiperInit();
	toggleItem();
	scrollAnimation();
	clickScrollToDiv(".list-toc-faq li a", () => {
		return $("header").outerHeight() - 50;
	});
	scrollToDivByCurrentUrl();
	wrapTagImgWithDiv();
	product.init();
	toolsContact();
	clickLoadMoreContent();
	loadMoreProduct();
	window.loadMoreProduct = loadMoreProduct;
});
function loadMoreProduct() {
	var infScrollProduct;
	if (window.matchMedia("(min-width: 1200px)").matches) {
		$("body").on("change", ".product-filter-category input, .product-filter-category select", function (e) {
			e.stopPropagation();
			$("button.apply-filters").trigger("click");
		});
	} else {
		$("body").on("click", "button.apply-filters", function () {
			$(".product-filter-category").removeClass("isOpen");
		});
	}
	if ($("body").find(".section-grid-product-border").length && $("body").find(".wrap-pagination-page").length) {
		$("body").find(".view-more-button").show();
		infScrollProduct = $("body").find(".section-grid-product-border").infiniteScroll({
			path: ".wrap-pagination-page .next.page-numbers",
			append: ".item-product-main",
			hideNav: ".wrap-pagination-page",
			checkLastPage: ".next.page-numbers",
			loadOnScroll: false,
			button: ".view-more-button",
			scrollThreshold: false,
			history: false,
			status: ".page-load-status",
		});
		infScrollProduct.on("append.infiniteScroll", function (event, body, path, items, response) {
			lozad().observe();
			console.log(`Appended ${items.length} items on ${path}`);
		});
		window[`infScrollProduct`] = infScrollProduct;
	} else {
		$("body").find(".view-more-button").hide();
	}
}
window[`loadMoreProduct`] = loadMoreProduct;
/*==================== ClickLoadMoreContent ====================*/
function clickLoadMoreContent() {
	// Check if content is overflow
	$(".title-category-san-pham .wrap").each(function () {
		const heightInit = 200;
		const heightContent = $(this).find(".content-hidden").outerHeight();
		if (heightContent <= heightInit) {
			$(this).addClass("isShow");
			$(this).parent().find(".btn-load-content").hide();
		}
	});
	$(".product-wrap-category .btn-load-content").on("click", function () {
		$(this).parents(".title-category-san-pham").find(".wrap").toggleClass("isShow");
		$(this)
			.toggleClass("active")
			.text(function (i, text) {
				return text === "Xem thêm" ? "Thu gọn" : "Xem thêm";
			});
	});
}
/*==================== Tools Contact ====================*/
function toolsContact() {
	$(".tools-contact").on("click", function () {
		$(this).find(".box-contact-show").toggleClass("active");
	});
	detectCloseElement(".tools-contact", "tools-contact", () => {
		$(".box-contact-show").removeClass("active");
	});
}
/*==================== ScrollToDivByCurrentUrl ====================*/
function scrollToDivByCurrentUrl() {
	const hashId = window.location.hash;
	if (hashId) {
		$("html, body").animate(
			{
				scrollTop: $(hashId).offset().top - $("header").outerHeight() - 50,
			},
			800
		);
	}
}
/*==================== wrapTagImgWithDiv ====================*/
function wrapTagImgWithDiv() {
	$(".section-collections-detail.section-noi-dung-tpn img").each(function () {
		const urlImg = $(this).attr("src");
		$(this).wrap(`<div class="img"><a class="cursor-zoom img-frame img-full" href="${urlImg}" data-fancybox></a></div>`);
	});
}
/*==================== Lazyload JS ====================*/
const observer = lozad(); // lazy loads elements with default selector as '.lozad'
window.observer = observer;
observer.observe();
